import { useCallback } from 'react';
import { useUserContext } from '@core/UserContext';
import { getApiLink } from '@core/utils/url';
import { ID } from '@models';
import { api } from './useFetch';

export const useCountrySwitch = () => {
    const { countries } = useUserContext();
    const currentCountry = countries.find(c => c.selected);

    const shouldSwitchCountry = useCallback((countryId: ID) => {
        return currentCountry && countryId !== currentCountry.id;
    }, [currentCountry]);

    const switchCountry = useCallback((countryId: ID) => {
        if (shouldSwitchCountry(countryId)) {
            return api.request({ 
                url: getApiLink('api/User/SetCountry', { countryId }) 
            }).finally(() => {
                window.location.reload();
            });
        }
    }, [shouldSwitchCountry]);

    return { switchCountry, shouldSwitchCountry };
};
